import { render, staticRenderFns } from "./addSubIbRuleDialog.vue?vue&type=template&id=51e6ea4d"
import script from "./addSubIbRuleDialog.vue?vue&type=script&lang=js"
export * from "./addSubIbRuleDialog.vue?vue&type=script&lang=js"
import style0 from "./addSubIbRuleDialog.vue?vue&type=style&index=0&id=51e6ea4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports